import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var ResultBox = styled.div.withConfig({
  displayName: "ResultBox",
  componentId: "sc-1fsve17-0"
})(["", ";transform:translateY(10px);user-select:none;"], getFont(0));
export var Results = styled.div.withConfig({
  displayName: "ResultBox__Results",
  componentId: "sc-1fsve17-1"
})(["padding:3px 0 12px;&:after{position:absolute;z-index:-1;top:0;bottom:0;left:-12px;right:-12px;border-bottom:1px solid ", ";content:'';}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderColor;
});